import React from "react";
import { CircularProgress, Backdrop } from "@mui/material";

function Loader() {
    return (
        <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.content, position: "absolute" }}
            open={true}
        >
            <CircularProgress color="secondary" />
        </Backdrop>
    );
}

export default Loader;
